import * as React from 'react';
import Toolbar from '../../basic/Toolbar';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import ADMTable from './ADMTable'
import * as Clients from '../../../client/ApiClient';
import { DataCell, DataTableButton } from '../../basic/DataTable';
import { Input  } from 'reactstrap';
import { saveAs } from 'file-saver';
import * as SourceSystem from 'constants/SourceSystem';

interface IADMPagePageState {
    selected: string
    stageTables: Clients.StageTablesModel[]
    columnTake: number
    conversion: Clients.ConversionModel | undefined;
}
interface ADMPageArgs {
    conversionId: string,
}

type ADMPageProps = RouteComponentProps<ADMPageArgs>;

class ADMPagePage extends React.Component<ADMPageProps, IADMPagePageState>{

    private mergeClient: Clients.MergeMapClient = new Clients.MergeMapClient();
    private report: Clients.ConversionReportsClient = new Clients.ConversionReportsClient();
    private conversion: Clients.ConversionClient = new Clients.ConversionClient();

    private readonly mergeNames =
        [{ mergeName: 'divisionmerge', entity: 'Divisions' },
        { mergeName: 'branchmerge', entity: 'Branches' },
        { mergeName: 'billingtransactions', entity: 'BillingTransactions' },
        { mergeName: 'paymentplans', entity: 'PaymentPlans' },
        { mergeName: 'departmentmerge', entity: 'Departments' },
        { mergeName: 'groupmerge', entity: 'Groups' },
        { mergeName: 'brokersmerge', entity: 'Brokers' },
        { mergeName: 'companymerge', entity: 'Companies' },
        { mergeName: 'employeemerge', entity: 'Employees' },
        { mergeName: 'kindoflossmerge', entity: 'KindsOfLoss' },
        { mergeName: 'lineofbusinessmerge', entity: 'LineOfBusiness' },
        { mergeName: 'profilequestions', entity: 'ProfileQuestion' }];

    constructor(props: Readonly<ADMPageProps>) {
        super(props)
        this.state = {
            selected: "",
            stageTables: [],
            columnTake: 0,
            conversion: undefined,
        }
    }

    componentDidMount() {
        this.getTables()
        this.currentConversion()
    }

    getTables = () => {
        this.mergeClient.getStageTables('ADM', this.props.match.params.conversionId)
            .then(response => {
                response && this.setState({ stageTables: response })
            })
            .catch(err => { console.error(err) })
    }

    currentConversion = () => {
        this.conversion.get(this.props.match.params.conversionId)
            .then(response =>
                this.setState({ conversion: response! })
            )
            .catch(error => { })
    }

    handleChange = (event: any) => {
        const selected = event.target.value
        let columnTake = 0;
        for (let i = 0; i < this.state.stageTables.length; i++) {
            if (this.state.stageTables[i].name === selected) {
                columnTake = this.state.stageTables[i].columnTake
            }
        }
        this.setState({ selected, columnTake })
    }

    exportToExcel = (table: string) => {
        const mergeName = this.mergeNames.filter(m => m.entity === table)
        const id = mergeName.length > 0 && this.state.conversion && this.state.conversion!.conversionTypeId.toUpperCase() !== SourceSystem.epicToAMS360Id ?
            mergeName[0].mergeName.concat("ADM") :
            table.toLowerCase().concat("ADM")
        this.report.exportToExcel(this.props.match.params.conversionId, id, null, null)
            .then(response => saveAs(response!.data, response!.fileName))
            .catch(error => {
                console.log(error)
            });
    }

    public render() {
        const stageTables = this.state.stageTables
        const conversionType = this.state.conversion && this.state.conversion!.conversionTypeId.toUpperCase() === SourceSystem.epicToAMS360Id ? "Epic" : "AMS360";
        const selected = this.state.selected !== '' ? this.state.selected : conversionType === "Epic" ? "All" : "allmerge";
        console.log(selected)
        return (
            <>
                <h3 className='mapping-body-header'>ADM Tables </h3>
                <Toolbar>
                    <DataCell>                       
                        <Input
                            className="custom-select tableSearch"
                            id={'stagetables'}
                            name={'stagetables'}
                            value={selected || ''}
                            type="select"
                            onChange={(event: any) => this.handleChange(event)}
                            placeholder={"Select Table"}
                        >
                            <option
                                key={0}
                                data-value={''}
                                value={''}
                            >
                                Select Table
                            </option>
                            {stageTables.map((table,i) => (
                                <option
                                    key={i}
                                    data-value={table.name}
                                >
                                    {table.name}
                                </option>
                            ))}
                        </Input >
                    </DataCell>
                    <DataTableButton
                        icon='file_download'
                        id='exportAllADM'
                        title={`Export ${selected.replace(/([A-Z])/g, ' $1').trim()} ADM Tables to Excel`}
                        action={() => this.exportToExcel(selected)} />
                </Toolbar>
                {this.state.selected !== "" && <ADMTable source='stage' conversionId={this.props.match.params.conversionId} sectionId={selected} columnTake={this.state.columnTake} />}
            </>
        )
    }
}

export default withRouter(ADMPagePage)